import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { RolePermissionGuard } from "./role.permission.guard";
import { AuthenticationService } from "../../services/api/authentication.service";

@Injectable()
export class IsCustomerPermissionGuard extends RolePermissionGuard {
  constructor(
    override applicationUserService: AuthenticationService,
    override router: Router
  ) {
    super(applicationUserService, router, ["Customer"], "/portal/home");
  }
}
